import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { PrivateFoundationsApi } from '../../../services'
import { IPrivateFoundation, RequestConfig } from '../../../types'
import { normalizeError } from '../../../utils'
import { PrivateFoundationInitialState } from '../../privateFoundation'

export const fetchPrivateFoundationAsync = createAsyncThunk(
  'privateFoundation/fetch',
  async (
    {
      foundationId,
      options,
    }: {
      foundationId: string
      options?: RequestConfig
    },
    { rejectWithValue },
  ) => {
    try {
      const res = await PrivateFoundationsApi.fetchPrivateFoundation(foundationId, options)

      return (res as AxiosResponse<any, any>).data
    } catch (error) {
      rejectWithValue(normalizeError(error, 'fetching private foundations'))
    }
  },
)

export const fetchPrivateFoundationAsyncBuilder = (
  builder: ActionReducerMapBuilder<PrivateFoundationInitialState>,
) => {
  builder
    .addCase(fetchPrivateFoundationAsync.pending, (state, _action) => {
      state.loading = true
      state.success = false
      state.error = ''
    })
    .addCase(
      fetchPrivateFoundationAsync.fulfilled,
      (state, action: PayloadAction<IPrivateFoundation>) => {
        state.data = action.payload
        state.success = true
        state.loading = false
      },
    )
    .addCase(fetchPrivateFoundationAsync.rejected, (state, action: PayloadAction<any>) => {
      state.error = action.payload
      state.loading = false
    })
}
